import { DraftButton } from '../draft-button/draft-button';
import { DraftDialog } from 'components/draft-dialog';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { getUnreadDraftsCount } from 'redux-store/selector';
import { useModalState } from 'hooks/useModalState';
import { TGetActivityFeedDraftsResponse } from 'redux-store/api/activity-feed';

interface IDraftButtonWithDialog {
  isLoading: boolean;
  isError: boolean;
  data: TGetActivityFeedDraftsResponse;
}

export const DraftButtonWithDialog = ({ data, isError, isLoading }: IDraftButtonWithDialog) => {
  const unreadDraftsCount = useAppSelector(getUnreadDraftsCount);
  const [isOpen, onOpen, onClose] = useModalState();

  return (
    <>
      <DraftButton
        draftsCount={data?.items.length}
        unreadCount={unreadDraftsCount}
        onClick={onOpen}
      />
      {isOpen && (
        <DraftDialog
          open={isOpen}
          isLoading={isLoading}
          isError={isError}
          data={data}
          onClose={onClose}
        />
      )}
    </>
  );
};
